module.exports = __webpack_public_path__ + "img/startup-small-business.6ee7fe6c.png";